import React, { useState } from "react";
import { notification } from "../../utils/Notifications.tsx";
import {
  deleteProofFile,
  uploadFilesToIncapacity,
} from "../../services/incapacities.service.ts";

const IncapacityFormEditFiles = ({ incapacity, reloadFiles, isDisabled = false }) => {
  const { proofFiles } = incapacity;
  const [newFiles, setNewFiles] = useState([]);
  const idIncapacity = incapacity.id;
  const [loading, setLoading] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);

  const handleDeleteNewFile = (fileIndex) => {
    setNewFiles((prevFiles) =>
      prevFiles.filter((_, index) => index !== fileIndex)
    );
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const files = Array.from(event.dataTransfer.files);
    setNewFiles((prevFiles) => [...prevFiles, ...files]);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    setNewFiles((prevFiles) => [...prevFiles, ...files]);
  };

  const handleUpload = async () => {
    setLoading(true);
    try {
      await uploadFilesToIncapacity(Number(idIncapacity), newFiles);
      notification("Éxito", "Archivos subidos correctamente", "success");
      setNewFiles([]);
      setLoading(false);
      reloadFiles();
    } catch (error) {
      console.error("Error al subir los archivos:", error);
      notification("Error", "No se pudieron subir los archivos", "danger");
      setLoading(false);
    }
  };

  const handleDelete = async (fileId) => {
    setLoading(true);
    try {
      await deleteProofFile(fileId);
      notification("Éxito", "Archivo eliminado correctamente", "success");
      setLoading(false);
      reloadFiles();
    } catch (error) {
      console.error("Error al eliminar el archivo:", error);
      notification("Error", "No se pudo eliminar el archivo", "danger");
      setLoading(false);
    }
  };

  const handleImageClick = (file) => {
    if (file.type && file.type.match(/(png|jpg|jpeg)$/)) {
      setPreviewImage(URL.createObjectURL(file));
    }
  };

  const handleExistingImageClick = (file) => {
    if (file.proofFile.extension.match(/(png|jpg|jpeg)$/)) {
      setPreviewImage(file.proofFile.url);
    }
  };

  const closePreview = () => {
    setPreviewImage(null);
  };

  const hasProofFiles = Array.isArray(proofFiles) && proofFiles.length > 0;

  return (
    <div className="row p-4">
      {!hasProofFiles && (
        <div className="col-12 mb-4">
          <div className="d-flex flex-column align-items-center justify-content-center py-4 text-muted">
            <i className="fas fa-file-circle-xmark mb-2" style={{ fontSize: "1.8rem" }}></i>
            <h6 className="mb-1">Sin evidencia</h6>
            <small className="text-secondary">
              No se adjuntaron documentos a esta incapacidad.
            </small>
          </div>
        </div>
      )}

      {newFiles.length > 0 && (
        <div className="col-12 mb-4">
          <h6>Archivos nuevos a subir:</h6>
          <div className="row">
            {newFiles.map((file, index) => (
              <div key={index} className="col-md-3 mb-3">
                <div className="card shadow-sm border-light rounded position-relative">
                  <div className="card-body text-center">
                    <div className="mb-3">
                      {file.type && file.type.match(/(png|jpg|jpeg)$/) ? (
                        <img
                          src={URL.createObjectURL(file)}
                          alt={file.name}
                          className="img-fluid rounded"
                          style={{
                            maxHeight: "150px",
                            objectFit: "cover",
                            cursor: "pointer",
                          }}
                          onClick={() => handleImageClick(file)}
                        />
                      ) : file.type && file.type.match(/(pdf)$/) ? (
                        <div>
                          <p>Archivo PDF, haz clic en "Ver".</p>
                          <a
                            href={URL.createObjectURL(file)}
                            className="btn btn-secondary"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Ver PDF
                          </a>
                        </div>
                      ) : (
                        <p>Vista previa no disponible</p>
                      )}
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <small className="text-muted">{file.name}</small>
                      {!isDisabled && (
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => handleDeleteNewFile(index)}
                          title="Eliminar"
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          {!isDisabled && (
            <div className="text-center mt-3">
              <button
                className="btn btn-success"
                onClick={handleUpload}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <i className="fas fa-spinner fa-spin me-2"></i>
                    Subiendo...
                  </>
                ) : (
                  <>
                    <i className="fas fa-upload me-2"></i>
                    Subir archivos
                  </>
                )}
              </button>
            </div>
          )}
        </div>
      )}

      {hasProofFiles && (
        <div className="col-12 mb-4">
          <h6>Archivos adjuntos:</h6>
          <div className="row">
            {proofFiles.map((file) => (
              <div key={file.id} className="col-md-3 mb-3">
                <div
                  className="card shadow-sm border-light rounded position-relative"
                  style={{ transition: "transform 0.2s", cursor: "pointer" }}
                  onClick={() => handleExistingImageClick(file)}
                >
                  <div className="card-body text-center">
                    <div className="mb-3">
                      {file.proofFile.extension.match(/(png|jpg|jpeg)$/) ? (
                        <img
                          src={file.proofFile.url}
                          alt={file.proofFile.name}
                          className="img-fluid rounded"
                          style={{
                            maxHeight: "150px",
                            objectFit: "cover",
                          }}
                        />
                      ) : file.proofFile.extension.match(/(pdf)$/) ? (
                        <div>
                          <p>Archivo PDF, haz clic en "Ver".</p>
                          <a
                            href={file.proofFile.url}
                            className="btn btn-secondary"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Ver PDF
                          </a>
                        </div>
                      ) : (
                        <p>Vista previa no disponible</p>
                      )}
                    </div>
                    {/* <div className="d-flex justify-content-between align-items-center">
                      <small className="text-muted">{file.proofFile.name}</small>
                      {!isDisabled && (
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDelete(file.id);
                          }}
                          title="Eliminar"
                          disabled={loading}
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      )}
                    </div> */}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {previewImage && (
        <div
          className="modal fade show d-block bg-black bg-opacity-75"
          tabIndex="-1"
          onClick={closePreview}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body text-center">
                <img
                  src={previewImage}
                  alt="Vista previa"
                  className="img-fluid"
                  style={{ maxHeight: "90vh", objectFit: "contain" }}
                />
              </div>
              <div className="modal-footer">
                <button className="btn btn-danger" onClick={closePreview}>
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default IncapacityFormEditFiles;
